import { render, staticRenderFns } from "./AddEditTrucksLog.vue?vue&type=template&id=04e4e404&scoped=true&"
import script from "./AddEditTrucksLog.vue?vue&type=script&lang=js&"
export * from "./AddEditTrucksLog.vue?vue&type=script&lang=js&"
import style0 from "./AddEditTrucksLog.vue?vue&type=style&index=0&id=04e4e404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e4e404",
  null
  
)

export default component.exports